import { gspApi as api } from './gsp';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    getApiAccountMe: build.query<GetApiAccountMeResponse, GetApiAccountMeArg>({
      query: () => ({ url: `/api/account/me` }),
    }),
    getApiAdminStudentSearch: build.query<
      GetApiAdminStudentSearchResponse,
      GetApiAdminStudentSearchArg
    >({
      query: queryArg => ({
        url: `/api/admin/student-search`,
        params: {
          Page: queryArg.page,
          ItemsPerPage: queryArg.itemsPerPage,
          IncludeFilterOptions: queryArg.includeFilterOptions,
          YearGroupId: queryArg.yearGroupId,
          Search: queryArg.search,
        },
      }),
    }),
    postApiAdminByStudentIdMasquerade: build.mutation<
      PostApiAdminByStudentIdMasqueradeResponse,
      PostApiAdminByStudentIdMasqueradeArg
    >({
      query: queryArg => ({
        url: `/api/admin/${queryArg.studentId}/masquerade`,
        method: 'POST',
      }),
    }),
    postApiAdminClearMasquerading: build.mutation<
      PostApiAdminClearMasqueradingResponse,
      PostApiAdminClearMasqueradingArg
    >({
      query: () => ({ url: `/api/admin/clear-masquerading`, method: 'POST' }),
    }),
    getApiAdminSchoolLinksManagerSearch: build.query<
      GetApiAdminSchoolLinksManagerSearchResponse,
      GetApiAdminSchoolLinksManagerSearchArg
    >({
      query: queryArg => ({
        url: `/api/admin/school-links-manager/search`,
        params: {
          Page: queryArg.page,
          ItemsPerPage: queryArg.itemsPerPage,
          IncludeFilterOptions: queryArg.includeFilterOptions,
          CategoryNames: queryArg.categoryNames,
          Audiences: queryArg.audiences,
        },
      }),
    }),
    getApiAdminSchoolLinksManagerLinkBySchoolLinkId: build.query<
      GetApiAdminSchoolLinksManagerLinkBySchoolLinkIdResponse,
      GetApiAdminSchoolLinksManagerLinkBySchoolLinkIdArg
    >({
      query: queryArg => ({
        url: `/api/admin/school-links-manager/link/${queryArg.schoolLinkId}`,
      }),
    }),
    putApiAdminSchoolLinksManagerLinkBySchoolLinkId: build.mutation<
      PutApiAdminSchoolLinksManagerLinkBySchoolLinkIdResponse,
      PutApiAdminSchoolLinksManagerLinkBySchoolLinkIdArg
    >({
      query: queryArg => ({
        url: `/api/admin/school-links-manager/link/${queryArg.schoolLinkId}`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    deleteApiAdminSchoolLinksManagerLinkBySchoolLinkId: build.mutation<
      DeleteApiAdminSchoolLinksManagerLinkBySchoolLinkIdResponse,
      DeleteApiAdminSchoolLinksManagerLinkBySchoolLinkIdArg
    >({
      query: queryArg => ({
        url: `/api/admin/school-links-manager/link/${queryArg.schoolLinkId}`,
        method: 'DELETE',
      }),
    }),
    postApiAdminSchoolLinksManagerLink: build.mutation<
      PostApiAdminSchoolLinksManagerLinkResponse,
      PostApiAdminSchoolLinksManagerLinkArg
    >({
      query: queryArg => ({
        url: `/api/admin/school-links-manager/link`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getApiAttendanceByStudentIdRecords: build.query<
      GetApiAttendanceByStudentIdRecordsResponse,
      GetApiAttendanceByStudentIdRecordsArg
    >({
      query: queryArg => ({
        url: `/api/attendance/${queryArg.studentId}/records`,
        params: {
          Page: queryArg.page,
          ItemsPerPage: queryArg.itemsPerPage,
          IncludeFilterOptions: queryArg.includeFilterOptions,
          StatusCategories: queryArg.statusCategories,
          SchoolTermId: queryArg.schoolTermId,
        },
      }),
    }),
    getApiDashboardByStudentId: build.query<
      GetApiDashboardByStudentIdResponse,
      GetApiDashboardByStudentIdArg
    >({
      query: queryArg => ({ url: `/api/dashboard/${queryArg.studentId}` }),
    }),
    getApiDashboardByStudentIdUpcomingAssignments: build.query<
      GetApiDashboardByStudentIdUpcomingAssignmentsResponse,
      GetApiDashboardByStudentIdUpcomingAssignmentsArg
    >({
      query: queryArg => ({
        url: `/api/dashboard/${queryArg.studentId}/upcoming-assignments`,
        params: {
          SubjectIds: queryArg.subjectIds,
          CountsTowardsFinalGrade: queryArg.countsTowardsFinalGrade,
          IncludeFilterOptions: queryArg.includeFilterOptions,
          ContinuationToken: queryArg.continuationToken,
        },
      }),
    }),
    getApiLocalesByLocaleId: build.query<
      GetApiLocalesByLocaleIdResponse,
      GetApiLocalesByLocaleIdArg
    >({
      query: queryArg => ({ url: `/api/locales/${queryArg.localeId}` }),
    }),
    postApiParentHelperAskQuestion: build.mutation<
      PostApiParentHelperAskQuestionResponse,
      PostApiParentHelperAskQuestionArg
    >({
      query: queryArg => ({
        url: `/api/parent-helper/ask-question`,
        method: 'POST',
        body: queryArg.inspiredGlobalStudyPlatformApiModelsParentHelperPostQuestionRequest,
      }),
    }),
    getApiParentHelperTopics: build.query<
      GetApiParentHelperTopicsResponse,
      GetApiParentHelperTopicsArg
    >({
      query: queryArg => ({
        url: `/api/parent-helper/topics`,
        params: { continuationToken: queryArg.continuationToken },
      }),
    }),
    putApiParentHelperTopicsFavourite: build.mutation<
      PutApiParentHelperTopicsFavouriteResponse,
      PutApiParentHelperTopicsFavouriteArg
    >({
      query: queryArg => ({
        url: `/api/parent-helper/topics/favourite`,
        method: 'PUT',
        body: queryArg.inspiredGlobalStudyPlatformApiModelsParentHelperPutFavoriteTopicRequest,
      }),
    }),
    getApiParentHelperChatsByChatId: build.query<
      GetApiParentHelperChatsByChatIdResponse,
      GetApiParentHelperChatsByChatIdArg
    >({
      query: queryArg => ({
        url: `/api/parent-helper/chats/${queryArg.chatId}`,
      }),
    }),
    deleteApiParentHelperChatsByChatId: build.mutation<
      DeleteApiParentHelperChatsByChatIdResponse,
      DeleteApiParentHelperChatsByChatIdArg
    >({
      query: queryArg => ({
        url: `/api/parent-helper/chats/${queryArg.chatId}`,
        method: 'DELETE',
      }),
    }),
    getApiParentHelperChatsLatest: build.query<
      GetApiParentHelperChatsLatestResponse,
      GetApiParentHelperChatsLatestArg
    >({
      query: () => ({ url: `/api/parent-helper/chats/latest` }),
    }),
    postApiParentHelperFeedbackByMessageId: build.mutation<
      PostApiParentHelperFeedbackByMessageIdResponse,
      PostApiParentHelperFeedbackByMessageIdArg
    >({
      query: queryArg => ({
        url: `/api/parent-helper/feedback/${queryArg.messageId}`,
        method: 'POST',
        body: queryArg.inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest,
      }),
    }),
    getApiProgressByStudentId: build.query<
      GetApiProgressByStudentIdResponse,
      GetApiProgressByStudentIdArg
    >({
      query: queryArg => ({ url: `/api/progress/${queryArg.studentId}` }),
    }),
    getApiProgressByStudentIdAndSubjectId: build.query<
      GetApiProgressByStudentIdAndSubjectIdResponse,
      GetApiProgressByStudentIdAndSubjectIdArg
    >({
      query: queryArg => ({
        url: `/api/progress/${queryArg.studentId}/${queryArg.subjectId}`,
      }),
    }),
    getApiSchoolLinks: build.query<
      GetApiSchoolLinksResponse,
      GetApiSchoolLinksArg
    >({
      query: () => ({ url: `/api/school-links` }),
    }),
    getApiSchoolLinksBySchoolLinkIdDownload: build.query<
      GetApiSchoolLinksBySchoolLinkIdDownloadResponse,
      GetApiSchoolLinksBySchoolLinkIdDownloadArg
    >({
      query: queryArg => ({
        url: `/api/school-links/${queryArg.schoolLinkId}/download`,
        params: { preview: queryArg.preview },
      }),
    }),
    getApiSchoolSettings: build.query<
      GetApiSchoolSettingsResponse,
      GetApiSchoolSettingsArg
    >({
      query: () => ({ url: `/api/school-settings` }),
    }),
    getApiSubjectsByStudentId: build.query<
      GetApiSubjectsByStudentIdResponse,
      GetApiSubjectsByStudentIdArg
    >({
      query: queryArg => ({ url: `/api/subjects/${queryArg.studentId}` }),
    }),
    getApiSubjectsByStudentIdAndSubjectIdOverview: build.query<
      GetApiSubjectsByStudentIdAndSubjectIdOverviewResponse,
      GetApiSubjectsByStudentIdAndSubjectIdOverviewArg
    >({
      query: queryArg => ({
        url: `/api/subjects/${queryArg.studentId}/${queryArg.subjectId}/overview`,
      }),
    }),
    getApiSubjectsByStudentIdAndSubjectIdAssignments: build.query<
      GetApiSubjectsByStudentIdAndSubjectIdAssignmentsResponse,
      GetApiSubjectsByStudentIdAndSubjectIdAssignmentsArg
    >({
      query: queryArg => ({
        url: `/api/subjects/${queryArg.studentId}/${queryArg.subjectId}/assignments`,
      }),
    }),
    getApiSubjectsByStudentIdAndSubjectIdResources: build.query<
      GetApiSubjectsByStudentIdAndSubjectIdResourcesResponse,
      GetApiSubjectsByStudentIdAndSubjectIdResourcesArg
    >({
      query: queryArg => ({
        url: `/api/subjects/${queryArg.studentId}/${queryArg.subjectId}/resources`,
        params: {
          page: queryArg.page,
          itemsPerPage: queryArg.itemsPerPage,
          moduleIds: queryArg.moduleIds,
          includeFilterOptions: queryArg.includeFilterOptions,
          resourceTypes: queryArg.resourceTypes,
        },
      }),
    }),
    getApiSubjectsByStudentIdAndSubjectIdSyllabus: build.query<
      GetApiSubjectsByStudentIdAndSubjectIdSyllabusResponse,
      GetApiSubjectsByStudentIdAndSubjectIdSyllabusArg
    >({
      query: queryArg => ({
        url: `/api/subjects/${queryArg.studentId}/${queryArg.subjectId}/syllabus`,
      }),
    }),
    getApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentId: build.query<
      GetApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentIdResponse,
      GetApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentIdArg
    >({
      query: queryArg => ({
        url: `/api/subjects/${queryArg.studentId}/${queryArg.subjectId}/assignments/${queryArg.assignmentId}`,
      }),
    }),
    getApiTimetableStudentByStudentId: build.query<
      GetApiTimetableStudentByStudentIdResponse,
      GetApiTimetableStudentByStudentIdArg
    >({
      query: queryArg => ({
        url: `/api/timetable/student/${queryArg.studentId}`,
        params: { date: queryArg.date, timespan: queryArg.timespan },
      }),
    }),
    getApiTimetableStudentByStudentIdAndSubjectIdOverview: build.query<
      GetApiTimetableStudentByStudentIdAndSubjectIdOverviewResponse,
      GetApiTimetableStudentByStudentIdAndSubjectIdOverviewArg
    >({
      query: queryArg => ({
        url: `/api/timetable/student/${queryArg.studentId}/${queryArg.subjectId}/overview`,
      }),
    }),
    getApiUserSettings: build.query<
      GetApiUserSettingsResponse,
      GetApiUserSettingsArg
    >({
      query: () => ({ url: `/api/user-settings` }),
    }),
    postApiUserSettings: build.mutation<
      PostApiUserSettingsResponse,
      PostApiUserSettingsArg
    >({
      query: queryArg => ({
        url: `/api/user-settings`,
        method: 'POST',
        body: queryArg.inspiredGlobalStudyPlatformApiModelsUserSettingsUpdateUserSettingsRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedGspApi };
export type GetApiAccountMeResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsAccountGetAccountResponse;
export type GetApiAccountMeArg = void;
export type GetApiAdminStudentSearchResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsAdminStudentSearchResponse;
export type GetApiAdminStudentSearchArg = {
  page?: number;
  itemsPerPage?: number;
  includeFilterOptions?: boolean;
  yearGroupId?: string;
  search?: string;
};
export type PostApiAdminByStudentIdMasqueradeResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsAccountGetAccountResponse;
export type PostApiAdminByStudentIdMasqueradeArg = {
  studentId: string;
};
export type PostApiAdminClearMasqueradingResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsAccountGetAccountResponse;
export type PostApiAdminClearMasqueradingArg = void;
export type GetApiAdminSchoolLinksManagerSearchResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsAdminSchoolLinksSearchResponse;
export type GetApiAdminSchoolLinksManagerSearchArg = {
  page?: number;
  itemsPerPage?: number;
  includeFilterOptions?: boolean;
  categoryNames?: string[];
  audiences?: InspiredGlobalStudyPlatformApiModelsSchoolLinkAudience[];
};
export type GetApiAdminSchoolLinksManagerLinkBySchoolLinkIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsAdminEditableSchoolLink;
export type GetApiAdminSchoolLinksManagerLinkBySchoolLinkIdArg = {
  schoolLinkId: string;
};
export type PutApiAdminSchoolLinksManagerLinkBySchoolLinkIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsAdminEditableSchoolLink;
export type PutApiAdminSchoolLinksManagerLinkBySchoolLinkIdArg = {
  schoolLinkId: string;
  body: {
    Name: string;
    Description?: string;
    Audiences: InspiredGlobalStudyPlatformApiModelsSchoolLinkAudience[];
    CategoryName: string;
    Url?: string;
    File?: Blob;
  };
};
export type DeleteApiAdminSchoolLinksManagerLinkBySchoolLinkIdResponse =
  /** status 200 Success */ undefined;
export type DeleteApiAdminSchoolLinksManagerLinkBySchoolLinkIdArg = {
  schoolLinkId: string;
};
export type PostApiAdminSchoolLinksManagerLinkResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsAdminEditableSchoolLink;
export type PostApiAdminSchoolLinksManagerLinkArg = {
  body: {
    Name: string;
    Description?: string;
    Audiences: InspiredGlobalStudyPlatformApiModelsSchoolLinkAudience[];
    CategoryName: string;
    Url?: string;
    File?: Blob;
  };
};
export type GetApiAttendanceByStudentIdRecordsResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsAttendanceGetAttendanceRecordsResponse;
export type GetApiAttendanceByStudentIdRecordsArg = {
  studentId: string;
  page?: number;
  itemsPerPage?: number;
  includeFilterOptions?: boolean;
  statusCategories?: InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceStatusCategory[];
  schoolTermId?: string;
};
export type GetApiDashboardByStudentIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsDashboardGetDashboardResponse;
export type GetApiDashboardByStudentIdArg = {
  studentId: string;
};
export type GetApiDashboardByStudentIdUpcomingAssignmentsResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsDashboardGetUpcomingAssignmentsResponse;
export type GetApiDashboardByStudentIdUpcomingAssignmentsArg = {
  studentId: string;
  subjectIds?: string[];
  countsTowardsFinalGrade?: boolean;
  includeFilterOptions?: boolean;
  continuationToken?: string;
};
export type GetApiLocalesByLocaleIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsLocalesGetLocaleResponse;
export type GetApiLocalesByLocaleIdArg = {
  localeId: string;
};
export type PostApiParentHelperAskQuestionResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsParentHelperPostQuestionResponse;
export type PostApiParentHelperAskQuestionArg = {
  inspiredGlobalStudyPlatformApiModelsParentHelperPostQuestionRequest: InspiredGlobalStudyPlatformApiModelsParentHelperPostQuestionRequest;
};
export type GetApiParentHelperTopicsResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsParentHelperGetParentHelperChatsTopicsResponse;
export type GetApiParentHelperTopicsArg = {
  continuationToken?: string;
};
export type PutApiParentHelperTopicsFavouriteResponse =
  /** status 200 Success */ undefined;
export type PutApiParentHelperTopicsFavouriteArg = {
  inspiredGlobalStudyPlatformApiModelsParentHelperPutFavoriteTopicRequest: InspiredGlobalStudyPlatformApiModelsParentHelperPutFavoriteTopicRequest;
};
export type GetApiParentHelperChatsByChatIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsParentHelperGetParentHelperChatResponse;
export type GetApiParentHelperChatsByChatIdArg = {
  chatId: string;
};
export type DeleteApiParentHelperChatsByChatIdResponse =
  /** status 200 Success */ undefined;
export type DeleteApiParentHelperChatsByChatIdArg = {
  chatId: string;
};
export type GetApiParentHelperChatsLatestResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsParentHelperGetParentHelperChatResponse;
export type GetApiParentHelperChatsLatestArg = void;
export type PostApiParentHelperFeedbackByMessageIdResponse = unknown;
export type PostApiParentHelperFeedbackByMessageIdArg = {
  messageId: string;
  inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest: InspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest;
};
export type GetApiProgressByStudentIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsProgressGetProgressOverviewResponse;
export type GetApiProgressByStudentIdArg = {
  studentId: string;
};
export type GetApiProgressByStudentIdAndSubjectIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsProgressGetSubjectProgressResponse;
export type GetApiProgressByStudentIdAndSubjectIdArg = {
  studentId: string;
  subjectId: string;
};
export type GetApiSchoolLinksResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsSchoolLinksGetSchoolLinksResponse;
export type GetApiSchoolLinksArg = void;
export type GetApiSchoolLinksBySchoolLinkIdDownloadResponse =
  /** status 200 Success */ Blob;
export type GetApiSchoolLinksBySchoolLinkIdDownloadArg = {
  schoolLinkId: string;
  preview?: boolean;
};
export type GetApiSchoolSettingsResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsSchoolSettingsGetSchoolSettingsResponse;
export type GetApiSchoolSettingsArg = void;
export type GetApiSubjectsByStudentIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsSubjectsGetSubjectsResponse;
export type GetApiSubjectsByStudentIdArg = {
  studentId: string;
};
export type GetApiSubjectsByStudentIdAndSubjectIdOverviewResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsSubjectsGetSubjectOverviewResponse;
export type GetApiSubjectsByStudentIdAndSubjectIdOverviewArg = {
  studentId: string;
  subjectId: string;
};
export type GetApiSubjectsByStudentIdAndSubjectIdAssignmentsResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsSubjectsGetAssignmentsResponse;
export type GetApiSubjectsByStudentIdAndSubjectIdAssignmentsArg = {
  studentId: string;
  subjectId: string;
};
export type GetApiSubjectsByStudentIdAndSubjectIdResourcesResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsSubjectsGetSubjectResourcesResponse;
export type GetApiSubjectsByStudentIdAndSubjectIdResourcesArg = {
  studentId: string;
  subjectId: string;
  page?: number;
  itemsPerPage?: number;
  moduleIds?: string[];
  includeFilterOptions?: boolean;
  resourceTypes?: InspiredGlobalStudyPlatformApiModelsSubjectsResourceType[];
};
export type GetApiSubjectsByStudentIdAndSubjectIdSyllabusResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsSubjectsGetSubjectSyllabusResponse;
export type GetApiSubjectsByStudentIdAndSubjectIdSyllabusArg = {
  studentId: string;
  subjectId: string;
};
export type GetApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsSubjectsGetAssignmentResponse;
export type GetApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentIdArg = {
  studentId: string;
  subjectId: string;
  assignmentId: string;
};
export type GetApiTimetableStudentByStudentIdResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsTimetableGetStudentTimetableResponse;
export type GetApiTimetableStudentByStudentIdArg = {
  studentId: string;
  date?: string;
  timespan?: InspiredGlobalStudyPlatformApiModelsTimetableTimetableTimespan;
};
export type GetApiTimetableStudentByStudentIdAndSubjectIdOverviewResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsTimetableGetTimetableSubjectOverviewResponse;
export type GetApiTimetableStudentByStudentIdAndSubjectIdOverviewArg = {
  studentId: string;
  subjectId: string;
};
export type GetApiUserSettingsResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsUserSettingsUserSettingsResponse;
export type GetApiUserSettingsArg = void;
export type PostApiUserSettingsResponse =
  /** status 200 Success */ InspiredGlobalStudyPlatformApiModelsUserSettingsUserSettingsResponse;
export type PostApiUserSettingsArg = {
  inspiredGlobalStudyPlatformApiModelsUserSettingsUpdateUserSettingsRequest: InspiredGlobalStudyPlatformApiModelsUserSettingsUpdateUserSettingsRequest;
};
export type InspiredGlobalStudyPlatformApiModelsAccountAccountType =
  | 'Student'
  | 'ParentOrGuardian'
  | 'Staff'
  | 'NonTeachingStaff'
  | 'Admin';
export type InspiredGlobalStudyPlatformApiModelsAccountStudent = {
  id: string;
  firstName: string;
  lastName: string;
  yearGroupName: string;
  formGroupName: string;
  profilePictureUrl?: string | null;
  hasLmsAccount: boolean;
};
export type InspiredGlobalStudyPlatformApiModelsAccountGetAccountResponse = {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  accountType: InspiredGlobalStudyPlatformApiModelsAccountAccountType;
  students: InspiredGlobalStudyPlatformApiModelsAccountStudent[];
  featureFlags: string[];
};
export type InspiredLibrariesApiExceptionHandlingErrorResponse = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  traceId?: string | null;
  errors?: {
    [key: string]: string[] | null;
  } | null;
  [key: string]: any;
};
export type InspiredGlobalStudyPlatformApiModelsPageInfo = {
  pageNumber: number;
  totalItems: number;
  totalPages: number;
  nextPageNumber: number;
  previousPageNumber: number;
};
export type InspiredGlobalStudyPlatformApiModelsPagedResults601InspiredGlobalStudyPlatformApiModelsAccountStudent20InspiredGlobalStudyPlatformApi20Version100020CultureNeutral20PublicKeyTokenNull =
  {
    data: InspiredGlobalStudyPlatformApiModelsAccountStudent[];
    paging: InspiredGlobalStudyPlatformApiModelsPageInfo;
  };
export type InspiredGlobalStudyPlatformApiModelsYearGroup = {
  id: string;
  name: string;
};
export type InspiredGlobalStudyPlatformApiModelsAdminStudentSearchFilters = {
  yearGroups: InspiredGlobalStudyPlatformApiModelsYearGroup[];
};
export type InspiredGlobalStudyPlatformApiModelsAdminStudentSearchResponse = {
  results: InspiredGlobalStudyPlatformApiModelsPagedResults601InspiredGlobalStudyPlatformApiModelsAccountStudent20InspiredGlobalStudyPlatformApi20Version100020CultureNeutral20PublicKeyTokenNull;
  filterOptions?: InspiredGlobalStudyPlatformApiModelsAdminStudentSearchFilters;
};
export type InspiredGlobalStudyPlatformApiModelsSchoolLinkAudience =
  | 'Student'
  | 'ParentOrGuardian'
  | 'Staff';
export type InspiredGlobalStudyPlatformApiModelsSchoolLinkType = 'Url' | 'File';
export type InspiredGlobalStudyPlatformApiModelsAdminEditableSchoolLink = {
  id: string;
  name: string;
  description?: string | null;
  categoryName: string;
  audiences: InspiredGlobalStudyPlatformApiModelsSchoolLinkAudience[];
  type: InspiredGlobalStudyPlatformApiModelsSchoolLinkType;
  url?: string | null;
  fileName?: string | null;
};
export type InspiredGlobalStudyPlatformApiModelsPagedResults601InspiredGlobalStudyPlatformApiModelsAdminEditableSchoolLink20InspiredGlobalStudyPlatformApi20Version100020CultureNeutral20PublicKeyTokenNull =
  {
    data: InspiredGlobalStudyPlatformApiModelsAdminEditableSchoolLink[];
    paging: InspiredGlobalStudyPlatformApiModelsPageInfo;
  };
export type InspiredGlobalStudyPlatformApiModelsAdminSchoolLinksSearchFilters =
  {
    categoryNames: string[];
    audiences: InspiredGlobalStudyPlatformApiModelsSchoolLinkAudience[];
  };
export type InspiredGlobalStudyPlatformApiModelsAdminSchoolLinksSearchResponse =
  {
    results: InspiredGlobalStudyPlatformApiModelsPagedResults601InspiredGlobalStudyPlatformApiModelsAdminEditableSchoolLink20InspiredGlobalStudyPlatformApi20Version100020CultureNeutral20PublicKeyTokenNull;
    filterOptions?: InspiredGlobalStudyPlatformApiModelsAdminSchoolLinksSearchFilters;
  };
export type MicrosoftAspNetCoreMvcProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type SystemDayOfWeek =
  | 'Sunday'
  | 'Monday'
  | 'Tuesday'
  | 'Wednesday'
  | 'Thursday'
  | 'Friday'
  | 'Saturday';
export type InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceStatusCategory =
  'Present' | 'Late' | 'OutOfSchool' | 'Absent';
export type InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceRecord = {
  id: string;
  dayOfWeek: SystemDayOfWeek;
  date: string;
  time: string;
  statusName: string;
  statusCategory: InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceStatusCategory;
  minutesLate?: number | null;
};
export type InspiredGlobalStudyPlatformApiModelsPagedResults601InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceRecord20InspiredGlobalStudyPlatformApi20Version100020CultureNeutral20PublicKeyTokenNull =
  {
    data: InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceRecord[];
    paging: InspiredGlobalStudyPlatformApiModelsPageInfo;
  };
export type InspiredGlobalStudyPlatformApiModelsSchoolTerm = {
  id?: string;
  name?: string;
  startDate?: string;
  endDate?: string;
};
export type InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceRecordsFilters =
  {
    statusCategories: InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceStatusCategory[];
    schoolTerms: InspiredGlobalStudyPlatformApiModelsSchoolTerm[];
  };
export type InspiredGlobalStudyPlatformApiModelsAttendanceGetAttendanceRecordsResponse =
  {
    numberOfAbsences: number;
    results: InspiredGlobalStudyPlatformApiModelsPagedResults601InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceRecord20InspiredGlobalStudyPlatformApi20Version100020CultureNeutral20PublicKeyTokenNull;
    filterOptions: InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceRecordsFilters;
  };
export type InspiredGlobalStudyPlatformApiModelsChartGradeType =
  | 'Cumulative'
  | 'Latest'
  | 'Average'
  | 'Aggregate';
export type InspiredGlobalStudyPlatformApiModelsAxisCoordinate = {
  label: string;
  value: number;
};
export type InspiredGlobalStudyPlatformApiModelsDataPoint = {
  id: string;
  xCoordinate: InspiredGlobalStudyPlatformApiModelsAxisCoordinate;
  yCoordinate: InspiredGlobalStudyPlatformApiModelsAxisCoordinate;
};
export type InspiredGlobalStudyPlatformApiModelsChartSeries = {
  id: string;
  label: string;
  dataPoints: InspiredGlobalStudyPlatformApiModelsDataPoint[];
};
export type InspiredGlobalStudyPlatformApiModelsChart = {
  gradeType: InspiredGlobalStudyPlatformApiModelsChartGradeType;
  xAxis: InspiredGlobalStudyPlatformApiModelsAxisCoordinate[];
  yAxis: InspiredGlobalStudyPlatformApiModelsAxisCoordinate[];
  seriesCollection: InspiredGlobalStudyPlatformApiModelsChartSeries[];
};
export type InspiredGlobalStudyPlatformApiModelsWorkflowState =
  | 'Upcoming'
  | 'Overdue'
  | 'MarkingInProgress'
  | 'Marked';
export type InspiredGlobalStudyPlatformApiModelsAssignmentOverviewGrade = {
  grade?: string | null;
  percentage: number;
};
export type InspiredGlobalStudyPlatformApiModelsAssignmentOverview = {
  id: string;
  name: string;
  subjectId: string;
  subjectName: string;
  categoryId: string;
  categoryName: string;
  countsTowardsFinalGrade: boolean;
  date?: string | null;
  state?: InspiredGlobalStudyPlatformApiModelsWorkflowState;
  mark?: InspiredGlobalStudyPlatformApiModelsAssignmentOverviewGrade;
};
export type InspiredGlobalStudyPlatformApiModelsDashboardGetDashboardResponse =
  {
    subjectGradesChart?: InspiredGlobalStudyPlatformApiModelsChart;
    upcomingAssignments: InspiredGlobalStudyPlatformApiModelsAssignmentOverview[];
    latestGradedAssignments: InspiredGlobalStudyPlatformApiModelsAssignmentOverview[];
  };
export type InspiredGlobalStudyPlatformApiModelsSubjectsSubject = {
  id: string;
  name: string;
  className: string;
  teachers: string[];
};
export type InspiredGlobalStudyPlatformApiModelsDashboardUpcomingAssignmentsFilters =
  {
    subjects: InspiredGlobalStudyPlatformApiModelsSubjectsSubject[];
  };
export type InspiredGlobalStudyPlatformApiModelsDashboardGetUpcomingAssignmentsResponse =
  {
    upcomingAssignments: InspiredGlobalStudyPlatformApiModelsAssignmentOverview[];
    filterOptions?: InspiredGlobalStudyPlatformApiModelsDashboardUpcomingAssignmentsFilters;
    nextPageUrl?: string | null;
  };
export type InspiredGlobalStudyPlatformApiModelsLocalesGetLocaleResponse = {
  id: string;
  tokens: {
    [key: string]: string;
  };
};
export type InspiredGlobalStudyPlatformApiModelsParentHelperPostQuestionResponse =
  {
    answer: string;
    messageId: string;
    chatId: string;
  };
export type InspiredGlobalStudyPlatformApiModelsParentHelperPostQuestionRequest =
  {
    question: string;
    chatId?: string | null;
  };
export type InspiredGlobalStudyPlatformApiModelsParentHelperParentHelperChatTopic =
  {
    chatId: string;
    createdDate: string;
    lastUpdatedDate: string;
    topic: string;
    isFavorite: boolean;
  };
export type InspiredGlobalStudyPlatformApiModelsParentHelperGetParentHelperChatsTopicsResponse =
  {
    topics: InspiredGlobalStudyPlatformApiModelsParentHelperParentHelperChatTopic[];
    nextPageUrl?: string | null;
  };
export type InspiredGlobalStudyPlatformApiModelsParentHelperPutFavoriteTopicRequest =
  {
    chatId: string;
    isFavorite: boolean;
  };
export type InspiredGlobalStudyPlatformApiModelsParentHelperChatMessage = {
  id: string;
  question: string;
  answer: string;
  isAnswerLiked: boolean;
};
export type InspiredGlobalStudyPlatformApiModelsParentHelperGetParentHelperChatResponse =
  {
    chatId: string;
    userId: string;
    topic: string;
    messages: InspiredGlobalStudyPlatformApiModelsParentHelperChatMessage[];
  };
export type InspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest =
  {
    liked: boolean;
    feedbackText?: string | null;
  };
export type InspiredGlobalStudyPlatformApiModelsProgressAttendanceRate = {
  statusCategory: InspiredGlobalStudyPlatformApiModelsAttendanceAttendanceStatusCategory;
  percentage: number;
};
export type InspiredGlobalStudyPlatformApiModelsProgressGetProgressOverviewResponse =
  {
    subjectGradesChart?: InspiredGlobalStudyPlatformApiModelsChart;
    latestGradedAssignments: InspiredGlobalStudyPlatformApiModelsAssignmentOverview[];
    attendanceRates?:
      | InspiredGlobalStudyPlatformApiModelsProgressAttendanceRate[]
      | null;
  };
export type InspiredGlobalStudyPlatformApiModelsAssignmentCategoryWeight = {
  categoryId: string;
  categoryName: string;
  percentageWeight: number;
};
export type InspiredGlobalStudyPlatformApiModelsSubjectGrade = {
  type: InspiredGlobalStudyPlatformApiModelsChartGradeType;
  percentage?: number | null;
  label?: string | null;
  assignmentCategoryWeights: InspiredGlobalStudyPlatformApiModelsAssignmentCategoryWeight[];
};
export type InspiredGlobalStudyPlatformApiModelsProgressGetSubjectProgressResponse =
  {
    id: string;
    name: string;
    subjectGrade?: InspiredGlobalStudyPlatformApiModelsSubjectGrade;
    subjectGrades: InspiredGlobalStudyPlatformApiModelsSubjectGrade[];
    assignmentsProgressChart?: InspiredGlobalStudyPlatformApiModelsChart;
    latestGradedAssignments: InspiredGlobalStudyPlatformApiModelsAssignmentOverview[];
    assignmentCategoryWeights: InspiredGlobalStudyPlatformApiModelsAssignmentCategoryWeight[];
  };
export type InspiredGlobalStudyPlatformApiModelsSchoolLinksSchoolLink = {
  id: string;
  name: string;
  description?: string | null;
  type: InspiredGlobalStudyPlatformApiModelsSchoolLinkType;
  url: string;
};
export type InspiredGlobalStudyPlatformApiModelsSchoolLinksSchoolLinksCollection =
  {
    categoryName: string;
    links: InspiredGlobalStudyPlatformApiModelsSchoolLinksSchoolLink[];
  };
export type InspiredGlobalStudyPlatformApiModelsSchoolLinksGetSchoolLinksResponse =
  {
    schoolLinks: InspiredGlobalStudyPlatformApiModelsSchoolLinksSchoolLinksCollection[];
  };
export type InspiredGlobalStudyPlatformApiModelsSchoolSettingsVisualSettings = {
  logoUrl: string;
  compactLogoUrl: string;
  favIconUrl: string;
};
export type InspiredGlobalStudyPlatformApiModelsSchoolSettingsChartSettings = {
  hideCumulativeGrades: boolean;
  hideAssignmentProgress: boolean;
};
export type InspiredGlobalStudyPlatformApiModelsSchoolTimeZone = {
  id: string;
  name: string;
  localDateTime: string;
  utcOffset: string;
};
export type InspiredGlobalStudyPlatformApiModelsSchoolSettingsSupportedLocale =
  {
    id: string;
    name: string;
  };
export type InspiredGlobalStudyPlatformApiModelsSchoolSettingsLocalizationSettings =
  {
    defaultLocale: string;
    supportedLocales: InspiredGlobalStudyPlatformApiModelsSchoolSettingsSupportedLocale[];
  };
export type InspiredGlobalStudyPlatformApiModelsSchoolSettingsLoginAudience =
  | 'Students'
  | 'Parents'
  | 'Staff';
export type InspiredGlobalStudyPlatformApiModelsSchoolSettingsLoginLink = {
  audience?: InspiredGlobalStudyPlatformApiModelsSchoolSettingsLoginAudience;
  url: string;
};
export type InspiredGlobalStudyPlatformApiModelsSchoolSettingsGetSchoolSettingsResponse =
  {
    schoolName: string;
    visual: InspiredGlobalStudyPlatformApiModelsSchoolSettingsVisualSettings;
    charts: InspiredGlobalStudyPlatformApiModelsSchoolSettingsChartSettings;
    timeZone: InspiredGlobalStudyPlatformApiModelsSchoolTimeZone;
    localization: InspiredGlobalStudyPlatformApiModelsSchoolSettingsLocalizationSettings;
    loginLinks: InspiredGlobalStudyPlatformApiModelsSchoolSettingsLoginLink[];
  };
export type InspiredGlobalStudyPlatformApiModelsSubjectsGetSubjectsResponse = {
  subjects: InspiredGlobalStudyPlatformApiModelsSubjectsSubject[];
};
export type InspiredGlobalStudyPlatformApiModelsSubjectsGetSubjectOverviewResponse =
  {
    id: string;
    name: string;
    upcomingAssignments: InspiredGlobalStudyPlatformApiModelsAssignmentOverview[];
    assignmentsProgressChart?: InspiredGlobalStudyPlatformApiModelsChart;
    assignmentCategoryWeights: InspiredGlobalStudyPlatformApiModelsAssignmentCategoryWeight[];
  };
export type InspiredGlobalStudyPlatformApiModelsSubjectsGetAssignmentsResponse =
  {
    assignments: InspiredGlobalStudyPlatformApiModelsAssignmentOverview[];
  };
export type InspiredGlobalStudyPlatformApiModelsSubjectsResourceType =
  | 'File'
  | 'Page'
  | 'Discussion'
  | 'ExternalUrl'
  | 'ExternalTool';
export type InspiredGlobalStudyPlatformApiModelsSubjectsModule = {
  id: string;
  name: string;
};
export type InspiredGlobalStudyPlatformApiModelsSubjectsResource = {
  id: string;
  name: string;
  url: string;
  type: InspiredGlobalStudyPlatformApiModelsSubjectsResourceType;
  module: InspiredGlobalStudyPlatformApiModelsSubjectsModule;
};
export type InspiredGlobalStudyPlatformApiModelsPagedResults601InspiredGlobalStudyPlatformApiModelsSubjectsResource20InspiredGlobalStudyPlatformApi20Version100020CultureNeutral20PublicKeyTokenNull =
  {
    data: InspiredGlobalStudyPlatformApiModelsSubjectsResource[];
    paging: InspiredGlobalStudyPlatformApiModelsPageInfo;
  };
export type InspiredGlobalStudyPlatformApiModelsSubjectsSubjectResourcesFilters =
  {
    resourceTypes: InspiredGlobalStudyPlatformApiModelsSubjectsResourceType[];
    modules: InspiredGlobalStudyPlatformApiModelsSubjectsModule[];
  };
export type InspiredGlobalStudyPlatformApiModelsSubjectsGetSubjectResourcesResponse =
  {
    results: InspiredGlobalStudyPlatformApiModelsPagedResults601InspiredGlobalStudyPlatformApiModelsSubjectsResource20InspiredGlobalStudyPlatformApi20Version100020CultureNeutral20PublicKeyTokenNull;
    filterOptions?: InspiredGlobalStudyPlatformApiModelsSubjectsSubjectResourcesFilters;
  };
export type InspiredGlobalStudyPlatformApiModelsSubjectsGetSubjectSyllabusResponse =
  {
    syllabus?: string | null;
  };
export type InspiredGlobalStudyPlatformApiModelsSubjectsAssignmentSubmission = {
  submittedAt: string;
  isLate: boolean;
  previewUrl?: string | null;
};
export type InspiredGlobalStudyPlatformApiModelsTextRemark = {
  remark: string;
};
export type InspiredGlobalStudyPlatformApiModelsMediaType =
  | 'Video'
  | 'Audio'
  | 'Unspecified';
export type InspiredGlobalStudyPlatformApiModelsMediaRemark = {
  mediaType: InspiredGlobalStudyPlatformApiModelsMediaType;
  contentType: string;
  url: string;
};
export type InspiredGlobalStudyPlatformApiModelsAttachment = {
  fileName: string;
  contentType: string;
  size: string;
  downloadUrl: string;
};
export type InspiredGlobalStudyPlatformApiModelsComment = {
  id: string;
  date: string;
  authorName: string;
  textRemark?: InspiredGlobalStudyPlatformApiModelsTextRemark;
  mediaRemark?: InspiredGlobalStudyPlatformApiModelsMediaRemark;
  attachments: InspiredGlobalStudyPlatformApiModelsAttachment[];
};
export type InspiredGlobalStudyPlatformApiModelsSubjectsAssignmentGrade = {
  gradedAt: string;
  pointsScore: number;
  percentage: number;
  grade?: string | null;
  pointsDeducted?: number | null;
  comments: InspiredGlobalStudyPlatformApiModelsComment[];
};
export type InspiredGlobalStudyPlatformApiModelsSubjectsGetAssignmentResponse =
  {
    id: string;
    name: string;
    descriptionHtml: string;
    subjectId: string;
    subjectName: string;
    categoryId: string;
    categoryName: string;
    url?: string | null;
    isSubmittable: boolean;
    countsTowardsFinalGrade: boolean;
    maximumPointsScore: number;
    dueDate?: string | null;
    state?: InspiredGlobalStudyPlatformApiModelsWorkflowState;
    submission?: InspiredGlobalStudyPlatformApiModelsSubjectsAssignmentSubmission;
    mark?: InspiredGlobalStudyPlatformApiModelsSubjectsAssignmentGrade;
  };
export type InspiredGlobalStudyPlatformApiModelsTimetableTimetableTimespan =
  | 'Day'
  | 'Week';
export type InspiredGlobalStudyPlatformApiModelsTimetableTimetablePeriod = {
  id: string;
  name: string;
  startTime: string;
  endTime: string;
  subjectName: string;
  teacherName: string;
  roomName: string;
  buildingName: string;
  subjectId?: string | null;
};
export type InspiredGlobalStudyPlatformApiModelsTimetableTimetableDay = {
  date: string;
  periods: InspiredGlobalStudyPlatformApiModelsTimetableTimetablePeriod[];
  assignments: InspiredGlobalStudyPlatformApiModelsAssignmentOverview[];
};
export type InspiredGlobalStudyPlatformApiModelsTimetableTimetable = {
  timespan: InspiredGlobalStudyPlatformApiModelsTimetableTimetableTimespan;
  weekScheduleName: string;
  days: InspiredGlobalStudyPlatformApiModelsTimetableTimetableDay[];
  firstDayOfWeek: SystemDayOfWeek;
};
export type InspiredGlobalStudyPlatformApiModelsTimetableGetStudentTimetableResponse =
  {
    timetable: InspiredGlobalStudyPlatformApiModelsTimetableTimetable;
    schoolTimeZone: InspiredGlobalStudyPlatformApiModelsSchoolTimeZone;
  };
export type InspiredGlobalStudyPlatformApiModelsTimetableGetTimetableSubjectOverviewResponse =
  {
    upcomingAssignments: InspiredGlobalStudyPlatformApiModelsAssignmentOverview[];
  };
export type InspiredGlobalStudyPlatformApiModelsUserSettingsUserSettingsResponse =
  {
    locale?: string | null;
  };
export type InspiredGlobalStudyPlatformApiModelsUserSettingsUpdateUserSettingsRequest =
  {
    locale?: string | null;
  };
